<template>
  <button type="button" class="nylon-AddButton" :class="{ 'nylon-AddButton--embedded': embedded }">
    <span class="nylon-AddButton-label"><slot /></span>
  </button>
</template>

<script>
/**
 * Nylon — AddButton
 *
 * The full-width "+ Add Another …" row: a bordered button with a round
 * "+" glyph and a left-aligned label. Reveals the next thing to add —
 * a color or size (ColorStylePanel, opening a <NylonChooserCard>), a
 * back print (the submission wizard and account edit-product), a
 * profile social link (account profile form).
 *
 * Props:
 * - `embedded` (default false): narrow-column sizing. The base steps
 *   height/padding up at @sm (the wizard's wide option column); embedded
 *   holds the compact size until @lg (the account edit-product column,
 *   the profile sidebar).
 *
 * Slots:
 * - `default`: the label text.
 *
 * Clicks fall through to the root <button> (`type="button"`, so it never
 * submits a surrounding form). Outer spacing is the consumer's: put a
 * descendant class of the parent on the component (e.g.
 * `.nylon-ColorStylePanel-newColor`) for its margins.
 */
export default {
  name: "NylonAddButton",
  props: {
    embedded: { type: Boolean, default: false },
  },
};
</script>
